import UsageTracker from '../../../utils/UsageTracker';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useSavedLearningInterest, useWizardResults } from '../../wizard';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useSearchFeedback } from '../../search';
import Raven from 'raven-js';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { useSearchState } from '../../search/searchStore';
import { isLessonRecommendation } from '../recommendationsUtils';
import { CardsSection } from '../../cardsSection/components/CardsSection';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleAction = ({
  resultsCount,
  resultsUrl
}) => {
  const handleViewResults = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-view-results-clicked'
    });
  };
  return resultsCount > 3 ? /*#__PURE__*/_jsx(RouterLink, {
    onClick: handleViewResults,
    to: resultsUrl,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.wizard.modal.stepfinal.resultslink",
      options: {
        resultsCount
      }
    })
  }) : null;
};
const SubTitle = ({
  selectedCategory,
  selectedCategoryGroup,
  selectedTool,
  selectedToolsGroup
}) => {
  const history = useHistory();
  const handleSetLearningInterest = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-set-learning-interest-clicked'
    });
    history.push('/wizard');
  };
  let message = null;
  if (selectedCategory) message = `learningCenter.topFilters.cat.${selectedCategory}`;else if (selectedCategoryGroup) message = `learningCenter.filtersGroups.${selectedCategoryGroup}`;else if (selectedTool) message = `learningCenter.topFilters.tools.${selectedTool}`;else if (selectedToolsGroup) message = `learningCenter.filtersGroups.${selectedToolsGroup}`;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message ? `learningCenter.tracks.subheaders.learningInterest` : `learningCenter.tracks.subheaders.learningInterestGeneric`,
    options: {
      learningInterest: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "learning-interest-label",
        message: message || ''
      }),
      setInterestLink: /*#__PURE__*/_jsx(RouterLink, {
        "data-test-id": "preference-change-button",
        onClick: handleSetLearningInterest,
        to: "/wizard",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.fieldLink.edit"
        })
      })
    }
  });
};
const useRecommendationsBasedOnProgressContent = () => {
  const learningInterest = useSavedLearningInterest();
  const {
    searchResults,
    resultsCount,
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    resultsUrl,
    correlationId,
    error,
    isRequesting
  } = useWizardResults(learningInterest);

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(({
      contentType,
      id,
      language,
      resultMLOptionId
    }) => {
      return {
        id,
        type: contentType,
        language: language,
        resultMLOptionId
      };
    })) || [],
    skip: !(searchResults !== null && searchResults !== void 0 && searchResults.length)
  });
  return {
    content: cardModels,
    loading: isRequesting || cardModelsLoading,
    error: error || cardModelsError,
    correlationId,
    resultsCount,
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    resultsUrl
  };
};
export const RecommendationsBasedOnInterest = () => {
  const {
    setLastClickedSearchResultItem
  } = useSearchState();
  const [sendSearchFeedback] = useSearchFeedback();
  const {
    content,
    loading,
    error,
    correlationId,
    resultsCount,
    selectedCategory,
    selectedCategoryGroup,
    selectedTool,
    selectedToolsGroup,
    resultsUrl
  } = useRecommendationsBasedOnProgressContent();
  const {
    isMobile
  } = useMediaQuery();
  const handleOnItemClick = ({
    id,
    type,
    language,
    resultMLOptionId,
    name
  }, position) => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: position + 1,
      contentId: id,
      contentType: type,
      name,
      recommendedBecauseTrackId: type === 'TRACK' && id,
      recommendedBecauseLessonId: isLessonRecommendation(type) && id,
      recommendationType: 'learning-interest'
    });
    setLastClickedSearchResultItem({
      item: {
        id,
        type: type,
        language: language || undefined
      },
      position
    });
    if (correlationId) sendSearchFeedback({
      variables: {
        correlationId,
        contentContainerType: type,
        resultMLOptionId
      }
    }).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsx(CardsSection, {
    appearsIn: "recommendations-interest",
    content: content,
    description: /*#__PURE__*/_jsx(SubTitle, {
      selectedCategory: selectedCategory,
      selectedCategoryGroup: selectedCategoryGroup,
      selectedTool: selectedTool,
      selectedToolsGroup: selectedToolsGroup
    }),
    displayFullCardsOnMobile: false,
    error: error,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.headers.recommended"
    }),
    headerActions: !isMobile && /*#__PURE__*/_jsx(TitleAction, {
      resultsCount: resultsCount,
      resultsUrl: resultsUrl
    }),
    isLoading: loading,
    navMarker: !loading && !error ? 'HOMEPAGE_RECOMMENDATIONS_LOADED' : undefined,
    onItemClick: handleOnItemClick,
    size: "extra-large"
  });
};
export default RecommendationsBasedOnInterest;